import React from 'react';
import {
  Box,
  Container,
  Grid,
  makeStyles,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
} from '@material-ui/core';
import { ApartmentOutlined } from '@material-ui/icons';
import Question from '../question/Question';

const OptionCard = ({
  icon,
  label,
  width,
  height,
  name,
  selectedValue,
  handleChange,
  hovercolor,
}) => {
  const useStyles = makeStyles({
    card: {
      width: 150,
      height: 150,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',

      '&:hover': {
        border:
          hovercolor == undefined
            ? '5px solid #1D85FE'
            : '5px solid ' + hovercolor,
        boxShadow: '0 9px 12px 0 rgba(0,0,0,.2)',
        transform: 'translateY(-2px)',
        padding: '0px',
      },
    },
    checkbox: {
      position: 'relative',
      top: '20px',
      left: '50px',
      backgroundColor: 'red !important',
    },
  });
  const classes = useStyles();

  return (
    <Card className={classes.card} variant="outlined">
      <CardContent>
        <div className="flex flex-col items-center text-center">
          <img src={icon} width="80px" onClick={handleChange} />
          <FormControlLabel
            className={name}
            control={
              <Checkbox
                checked={selectedValue == 1}
                color="primary"
                onChange={handleChange}
              />
            }
            label={label}
            labelPlacement="start"
          />
        </div>
      </CardContent>
    </Card>
  );
};

const Optionscard = ({ daten, cardcontent, handleUpdate, url, hovercolor }) => {
  let cardID =
    daten['chain'].length > 0
      ? daten['chain'][daten['chain'].length - 1].toString()
      : daten['chain'][0].toString();
  let step = daten['chain'].length;

  'selection' in daten['info'][cardID]
    ? 0
    : (daten['info'][cardID]['selection'] = {});

  const handleChange = (index, checked) => {
    cardID in daten['info'] ? 0 : (daten['info'][cardID] = {}); //Create Dict in Info if not exists
    'selection' in daten['info'][cardID]
      ? 0
      : (daten['info'][cardID]['selection'] = {}); //Create Dict in Info if not exists

    daten['info'][cardID]['selection'][index] = checked;
    handleUpdate(daten);
  };

  let renderObjekt = (
    <Grid container justifyContent="center" spacing={4}>
      {cardcontent['optioncard'].map((i, index) => (
        <Grid key={i} item>
          <OptionCard
            width={150}
            height={110}
            selectedValue={
              index in daten['info'][cardID]['selection']
                ? daten['info'][cardID]['selection'][index]
                : 0
            }
            handleChange={() =>
              handleChange(
                index,
                index in daten['info'][cardID]['selection']
                  ? !daten['info'][cardID]['selection'][index]
                  : 1
              )
            }
            label={i}
            icon={url + cardcontent['images'][index]}
            hovercolor={hovercolor}
          />
        </Grid>
      ))}
    </Grid>
  );

  return (
    <div className="h-full flex flex-col justify-between" id="optionscard">
      <div className="text-center mt-40px">
        <Question questionNo={step} questionText={cardcontent['headline']} />
      </div>
      <div>
        <div>{renderObjekt}</div>
      </div>

      <div className="h-40px"></div>
    </div>
  );
};

export default Optionscard;
